import { render, staticRenderFns } from "./maritimeDeclaration.vue?vue&type=template&id=02391495&scoped=true"
import script from "./maritimeDeclaration.vue?vue&type=script&lang=js"
export * from "./maritimeDeclaration.vue?vue&type=script&lang=js"
import style0 from "./maritimeDeclaration.vue?vue&type=style&index=0&id=02391495&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02391495",
  null
  
)

export default component.exports